import axios from 'axios'
import qs from 'qs'

const ERR_OK = 3001

export function get(url) {
  return function(params = {}) {
    return axios.get(url, {
      params
    }).then(res => {
      return res.data
    }).catch((error) => {
      console.log('error', error)
    })
  }
}

export function post(url) {
  return function(data) {
    return axios({
      url,
      method: 'post',
      data: qs.stringify(data)
    }).then(res => {
      return res.data
    }).catch((error) => {
      console.log('error', error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/serve.js